import React from 'react';

import 'react-dual-listbox/lib/react-dual-listbox.css';

import { DualListBox } from '~/components/DualListBox';
import { useImpressao } from '~/components/Impressao/ImpressaoContext';
import { enrichItems } from '../../utils/enrichItems';

export const DualListComponent: React.FC<{
  componentRole?: 'visualizacao' | 'impressao';
}> = ({ componentRole = 'visualizacao' }) => {
  const {
    optionsAvailable,
    selected,
    changeSelected,
    setOptionsAvailable,
    views,
  } = useImpressao();

  const handleChange = (items: any) => {
    const item =
      componentRole === 'impressao' ? enrichItems(items, views) : items;

    changeSelected(item);
  };

  return (
    <DualListBox
      optionAvailable={optionsAvailable}
      setOptionAvailable={setOptionsAvailable}
      optionSelected={selected}
      setOptionSelected={handleChange}
      componentRole={componentRole}
      views={views}
    />
  );
};
